import { useEffect, useState } from "react";
import { formatLanguague, getCountryInfo } from "../utils/utilidades";
import { TOptions } from "@mercadopago/sdk-react/esm/mercadoPago/initMercadoPago/type";


export const useCountryAndCurrency = () => {
  const [country, setCountry] = useState("");
  const [currency, setCurrency] = useState("");
  const [language, setLanguage] = useState<TOptions["locale"]>("es-CL");

  useEffect(() => {
    getCountryInfo()
      .then((data:any) => {
        setCountry(data.country);
        setCurrency(data.currency);
        setLanguage(formatLanguague(data.country));
      })
      .catch((err) => console.error("Error fetching country info:", err));
  }, []);

  return { country, currency, language };
};
